import { Grid, Typography } from "@mui/material";
import React, { useContext, useRef } from "react";
import PaperGridItem from "../PaperGridItem";
import { chunk } from "lodash";
import MagazineConfig from "../../config";

const PaperGrid = ({ title, items }) => {
  const wrapperRef = useRef(null);
  const config = useContext(MagazineConfig);

  const showHeading =
    title !== undefined && typeof title === "string" && title.length > 0;
  const rowsPerColumn = config.NO_OF_AD_ROWS_PER_PAGE - (showHeading ? 1 : 0);
  const columnItemChunks = chunk(items, rowsPerColumn);

  return (
    <Grid container direction="row" width={1} padding={1} ref={wrapperRef}>
      {showHeading && (
        <Grid item xs={12} padding={3} height="10%">
          <Typography variant="h3" textAlign="center">
            {title}
          </Typography>
        </Grid>
      )}
      {columnItemChunks.map((columnItems, rowIndex) => (
        <Grid item xs={3} key={`row-${rowIndex}`} container direction="column">
          {columnItems.map((item, columnIndex) => {
            return (
              <Grid item padding={0.5}>
                <PaperGridItem
                  advertisment={item}
                  key={`row-${rowIndex}-col-${columnIndex}`}
                />
              </Grid>
            );
          })}
        </Grid>
      ))}
    </Grid>
  );
};

export default PaperGrid;
